module.exports = __webpack_public_path__ + "static/img/aboutPic1.382db3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutPic1.png
// module id = NhkF
// module chunks = 1